import { Property } from '@/components/form/fields/select/SelectInput';
import { useMemo } from 'react';
import { PoStatus } from './usePurchaseOrderService';
import { displayPurchaseOrderState } from './displayPurchaseOrderState';

export const usePoStateDropdownOptions = () => {
  return useMemo(() => {
    const statuses = [
      PoStatus.Draft,
      PoStatus.WarehouseProcessing,
      PoStatus.InTransit,
      PoStatus.Delivered,
      PoStatus.Complete
    ];
    const options: Property[] = statuses.map(s => ({ id: s.toString(), name: displayPurchaseOrderState(s) }));

    return options;
  }, []);
};
